/* hs-eslint ignored failing-rules */
/* eslint-disable promise/catch-or-return */

'use es6';

import { Component } from 'react';
import { connect } from 'react-redux';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import { ConfirmModal } from 'foundations-components/transitional/components/ConfirmModal';
import { setIframeLoading as setIframeLoadingAction, toggleApplyChangesModalOpen as toggleApplyChangesModalOpenAction } from 'ContentEditorUI/redux/actions/appActions';
import { updateSelectedItem as updateSelectedItemAction, clearSelectedItem as clearSelectedItemAction } from 'ContentEditorUI/redux/actions/selectionActions';
import { fetchPageCssAssets as fetchPageCssAssetsAction } from 'ContentEditorUI/redux/actions/contentAssetsActions';
import { getSelectionInProgress } from 'ContentEditorUI/redux/selectors/selectionSelectors';
import withEditorActionsAndEvents from 'ContentEditorUI/components/hoc/withEditorActionsAndEvents';
import { setApplyChangesButtonOpen as setApplyChangesButtonOpenAction } from 'ContentEditorUI/redux/actions/editSidebarActions';
import { getRoutingInProgress } from 'ContentEditorUI/redux/selectors/appStatusSelectors';
import { clearInpageUIState as clearInpageUIStateAction } from 'ContentEditorUI/redux/actions/inpageActions';
import { routeToTab as routeToTabAction } from 'ContentEditorUI/redux/actions/routingActions';
import { toggleDistractionFree as toggleDistractionFreeAction } from 'ContentEditorUI/redux/actions/distractionFreeActions';
import { getDistractionFreeInProgress } from 'ContentEditorUI/redux/selectors/distractionFreeSelectors';

/**
 * @param {Object} props
 * @param {Function} props.toggleApplyChangesModalOpen (required)
 * @param {Function} props.setIframeLoading (required)
 * @param {Function} props.fetchPageCssAssets (required)
 * @param {Object} [props.selectionInProgress] (optional)
 * @param {Function} props.updateSelectedItem (required)
 * @param {Function} props.autoSave (required)
 * @param {Function} props.clearSelectedItem (required)
 * @param {Function} props.setApplyChangesButtonOpen (required)
 * @param {Object} [props.routingInProgress] (optional)
 * @param {Function} props.clearInpageUIState (required)
 * @param {Function} props.routeToTab (required)
 * @param {Object} props.bus (required)
 * @param {boolean} props.distractionFreeInProgress (required)
 * @param {Function} props.toggleDistractionFree (required)
 */
import { jsx as _jsx } from "react/jsx-runtime";
class ApplyChangesModal extends Component {
  constructor(props) {
    super(props);
    this.applyChanges = this.applyChanges.bind(this);
  }
  applyChanges() {
    const {
      fetchPageCssAssets,
      setIframeLoading,
      toggleApplyChangesModalOpen,
      selectionInProgress,
      updateSelectedItem,
      clearSelectedItem,
      bus,
      autoSave,
      setApplyChangesButtonOpen,
      routingInProgress,
      clearInpageUIState,
      routeToTab,
      distractionFreeInProgress,
      toggleDistractionFree
    } = this.props;
    setIframeLoading({
      scrollIfAnyBoundsOutOfView: selectionInProgress
    });
    autoSave().then(() => {
      fetchPageCssAssets();
      bus.trigger('preview:refresh');
    });
    if (selectionInProgress) {
      updateSelectedItem(selectionInProgress.id, selectionInProgress);
    } else if (routingInProgress) {
      clearInpageUIState();
      routeToTab(routingInProgress.target);
    } else if (distractionFreeInProgress) {
      toggleDistractionFree(distractionFreeInProgress);
    } else {
      clearSelectedItem();
    }
    setApplyChangesButtonOpen(false);
    toggleApplyChangesModalOpen(false);
  }
  render() {
    const {
      toggleApplyChangesModalOpen
    } = this.props;
    return /*#__PURE__*/_jsx(ConfirmModal, {
      message: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "components.modals.moduleApplyChangesModal.header"
      }),
      description: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
        message: "components.modals.moduleApplyChangesModal.descriptionText"
      }),
      confirmLabel: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "components.modals.moduleApplyChangesModal.applyChanges"
      }),
      onConfirm: this.applyChanges,
      rejectLabel: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "components.modals.moduleApplyChangesModal.continueEditing"
      }),
      onReject: () => toggleApplyChangesModalOpen(false)
    });
  }
}
const mapStateToProps = state => ({
  selectionInProgress: getSelectionInProgress(state),
  routingInProgress: getRoutingInProgress(state),
  distractionFreeInProgress: getDistractionFreeInProgress(state)
});
export default connect(mapStateToProps, {
  setIframeLoading: setIframeLoadingAction,
  toggleApplyChangesModalOpen: toggleApplyChangesModalOpenAction,
  fetchPageCssAssets: fetchPageCssAssetsAction,
  updateSelectedItem: updateSelectedItemAction,
  clearSelectedItem: clearSelectedItemAction,
  setApplyChangesButtonOpen: setApplyChangesButtonOpenAction,
  clearInpageUIState: clearInpageUIStateAction,
  routeToTab: routeToTabAction,
  toggleDistractionFree: toggleDistractionFreeAction
})(withEditorActionsAndEvents(ApplyChangesModal));